<template>
	<div :class="{'ly-is-full':isFull}">
		<div class="tableSelect" ref="tableSelect">
			<el-form :inline="true" :model="formInline" ref="queryFrom" label-position="left">
				<!-- <el-form-item label="关键字：">
					<el-input v-model="formInline.keyword" placeholder="请输入关键字"></el-input>
				</el-form-item> -->
				<el-form-item label="文章分类：">
					<el-select v-model="formInline.category" placeholder="请选择文章分类" clearable filterable style="width: 200px">
						<el-option v-for="item in categorys" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属栏目：">
					<el-select v-model="formInline.column" placeholder="请选择所属栏目" clearable filterable style="width: 200px">
						<el-option v-for="item in columns" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态：">
					<el-select v-model="formInline.status" placeholder="请选择文章状态" clearable filterable style="width: 200px">
						<el-option v-for="item in states" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="">
					<el-button @click="handleSearchClick('search')" type="primary" icon="Search">查询</el-button>
				</el-form-item>
				<el-form-item label="">
					<el-button @click="handleSearchClick('reset')" icon="Refresh">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="table">
			<div class="tableToolBar">
				<div>
					<el-button type="primary" icon="Plus"
						@click="$router.push({path:'/article-add',query:routerInfo})">新增</el-button>
					<el-button type="danger" icon="Delete" :disabled="selectList.length == 0"
						@click="removeHandler">删除</el-button>
				</div>
			</div>
			<el-table v-bind="tableOptions" :data="tableData" :height="tableHeight" ref="tableref" row-key="id"
				style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" align="center" />
				<el-table-column prop="sort" label="排序" width="60" align="center" />
				<el-table-column prop="title" label="文章标题" width="300" align="center" />
				<el-table-column prop="column" label="所属栏目" width="200" align="center">
					<template #default="{row,$index}">
						<el-tag v-for="item in row.column" type="primary" effect="plain">{{item.name}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column type="state" label="文章状态" align="center" width="180">
					<template #default="{row,$index}">
						<el-tag v-if="row.status == 'published'" type="primary">已发布</el-tag>
						<el-tag v-else-if="row.status == 'draft'" type="success">草稿</el-tag>
						<el-tag v-else-if="row.status == 'pending'" type="warning">待定</el-tag>
						<el-tag v-else type="danger">不通过</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="category" label="文章分类" width="200" align="center">
					<template #default="{row,$index}">
						<span>{{row.category.name}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="author" label="作者" width="180" align="center" />
				<el-table-column label="创建者" width="180" align="center">
					<template #default="scope">
						<span>{{scope.row.creator.name}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="publish_time" label="发布时间" width="180" align="center" />
				<!-- <el-table-column prop="create_datetime" label="创建时间" width="180" align="center" /> -->
				<el-table-column prop="update_datetime" label="更新时间" width="180" align="center" />
				<el-table-column label="操作" align="center" width="280" fixed="right">
					<template #header>
						<div style="display: flex;justify-content: space-between;align-items: center;">
							<div>操作</div>
							<div @click="setFull">
								<el-tooltip content="全屏" placement="bottom">
									<el-icon><full-screen /></el-icon>
								</el-tooltip>
							</div>
						</div>
					</template>
					<template #default="scope">
						<!--  -->
						<el-button v-if="scope.row.status == 'pending'" icon="Edit" type="warning" plain text size="small"
							@click="examineHandler(scope.row)">审核</el-button>
						<el-button icon="Edit" type="primary" plain text size="small" @click="editHandler(scope.row)">编辑</el-button>
						<el-button icon="Delete" type="danger" plain text size="small" @click="removeRow(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<Pagination :child-msg="formInline" @callFather="callFather" />
	</div>
</template>

<script setup>
	import Pagination from "@/components/Pagination"
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'
	import {
		useRouter,
		useRoute
	} from "vue-router"
	import {
		ref,
		reactive,
		watch,
		onMounted,
		onUnmounted,
		nextTick
	} from "vue"
	import {
		getTableHeight
	} from "@/utils/util"
	import {
		articleGet,
		columnGet,
		categoryGet,
		articleDelete
	} from "@/api/court"

	const router = useRouter()
	const route = useRoute()

	//静态数据
	const states = [{
		label: '草稿',
		value: 'draft'
	}, {
		label: '待定',
		value: 'pending'
	}, {
		label: '不通过',
		value: 'fail'
	}, {
		label: '已发布',
		value: 'published'
	}]

	//页面元素
	const tableSelect = ref(null)
	const queryFrom = ref(null)

	//页面所需数据、变量
	const tableData = ref([]) //表格数据
	const tableHeight = ref(500) //表格高度
	const isFull = ref(false)
	const selectList = ref([])

	const columns = ref([]) //所属栏目数据
	const categorys = ref([]) //文章分类数据

	//查询表单 - 从URL参数中恢复状态
	const formInline = reactive({
		page: route.query.page ? parseInt(route.query.page) : 1,
		limit: route.query.limit ? parseInt(route.query.limit) : 10,
		total: 0,
		keyword: route.query.keyword || "",
		category: route.query.category || "",
		column: route.query.column ? parseInt(route.query.column) : '',
		status: route.query.status || ""
	})

	//表格配置项
	const tableOptions = ref({
		stripe: false, // 斑马纹
		highlightCurrentRow: false, // 是否要高亮当前行
		border: true, // 是否有纵向边框
		fit: true, // 列的宽度是否自撑开
		size: 'default', // Table 的尺寸
		lazy: false, // 是否需要懒加载
		showHeader: true, //是否显示表头
		defaultExpandAll: false, //是否默认展开所有行
	})

	const routerInfo = ref({
		...route.query,
		sort: 1
	})

	/**
	 * 页面初始化事件
	 */
	function initPage() {
		const param = JSON.parse(JSON.stringify(formInline))
		if(!param.column)delete param.column
		articleGet(param).then(res => {
			if (res.code == 2000) {
				formInline.total = res.data.total
				tableData.value = res.data.data
				if (formInline.page == 1 && res.data.total) {
					routerInfo.value.sort = res.data.data[0].sort + 1
				}
			}
		})
	}

	function otherInfoInit() {
		columnGet({
			page: 1,
			limit: 10000
		}).then(res => {
			if (res.code == 2000) {
				columns.value = res.data.data
			}
		})
		categoryGet({
			page: 1,
			limit: 10000
		}).then(res => {
			if (res.code == 2000) {
				categorys.value = res.data.data
			}
		})
	}

	//搜索栏中的查询与重置按钮事件
	function handleSearchClick(type) {
		if ("reset" == type) {
			Object.assign(formInline, {
				keyword: "",
				category: "",
				column: "",
				status: ""
			})
		}
		initPage()
	}

	//多选框选中的数据
	function handleSelectionChange(selection) {
		selectList.value = selection
	}

	//表格中的删除事件 所有的删除事件需要进行一次确认 直接将这一行数据放到selectList数组中
	function removeRow(data) {
		ElMessageBox.confirm('是否确认删除当前行的数据', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(f => {
			remove([data])
		})
	}

	//根据选中的数据进行删除 删除完毕后需要清空selectList数组
	function removeHandler() {
		ElMessageBox.confirm('是否确认删除当前选中的的数据', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(f => {
			remove(selectList.value)
		})
	}

	function remove(arr) {
		let flags = []
		arr.map(item => {
			articleDelete(item.id).then(res => {
				if (res.code == 2000) {
					flags.push(true)
					if (flags.length == arr.length) {
						ElMessage.success("文章删除成功")
						initPage()
					}
				} else ElMessage.warning(res.msg)
			})
		})
	}

	//表格中编辑事件 data为那一行的数据
	function editHandler(data) {
		// 保存当前查询状态，传递给编辑页面
		const currentQuery = {
			id: data.id,
			// 保存列表页的查询参数
			listPage: formInline.page,
			listLimit: formInline.limit,
			listKeyword: formInline.keyword,
			listCategory: formInline.category,
			listColumn: formInline.column,
			listStatus: formInline.status
		}

		router.push({
			path: '/article-edit',
			query: currentQuery
		})
	}

	//表格中的审核事件
	function examineHandler(data) {
		router.push({
			path: '/examine',
			query: {
				id: data.id
			}
		})
	}

	//分页sizechange、pagechange事件
	function callFather(params) {
		formInline.limit = params.limit
		formInline.page = params.page
		initPage()
	}

	//表格全屏
	function setFull() {
		isFull.value = !isFull.value
		window.dispatchEvent(new Event('resize'))
	}

	//获取表格高度
	function getTheTableHeight() {
		let tabSelectHeight = tableSelect ? tableSelect.value.offsetHeight : 0
		tabSelectHeight = isFull.value ? tabSelectHeight - 110 : tabSelectHeight
		tableHeight.value = getTableHeight(tabSelectHeight, false) - 225
	}

	//全局监听浏览器大小变化
	function listenResize() {
		nextTick(() => {
			getTheTableHeight()
		})
	}

	onMounted(() => {
		initPage()
		otherInfoInit()
		getTheTableHeight()
		window.addEventListener('resize', listenResize);
	})

	onUnmounted(() => {
		window.removeEventListener("resize", listenResize);
	})
</script>

<style scoped lang="scss">
	.tableToolBar {
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		background: var(--el-bg-color);
		padding: 8px;
		/*box-shadow: 0 0 4px #cccccc;*/
		/*box-shadow: 0 0 4px rgba(0, 0, 0, .12);*/
		border-top: 1px solid var(--el-border-color-lighter);
		border-left: 1px solid var(--el-border-color-lighter);
		border-right: 1px solid var(--el-border-color-lighter);
	}
</style>